import { isCredentialExpired } from "@/features/credentials/pages/list/lib/format-expiry";
import { cn } from "@cmde/shadcn";
import { Hint } from "@cmde/shadcn";
import { TriangleAlertIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const expiredCredentialRowClassName =
  "[&_tr:has([data-expired=true])]:bg-destructive/10 [&_tr:has([data-expired=true]):hover]:bg-destructive/15";

export function CredentialNameCell({ name, expiryDate }: { name: string; expiryDate?: string | null }) {
  const { t } = useTranslation();
  const expired = isCredentialExpired(expiryDate);

  return (
    <span className="flex items-center gap-2" data-expired={expired ? "true" : undefined}>
      {expired ? (
        <Hint content={t("credentials.list.expiry.expired")}>
          <span className="inline-flex shrink-0" aria-label={t("credentials.list.expiry.expired")}>
            <TriangleAlertIcon className="text-destructive size-4" aria-hidden />
          </span>
        </Hint>
      ) : null}
      <span className={cn(expired && "text-destructive")}>{name}</span>
    </span>
  );
}
